import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TypingIndicator } from 'ts-components/Chat/TypingIndicator';

const IndicatorWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 100px 0;
`;

export const Indicator = ({
  messages = [],
  delay = 15000,
}: {
  messages?: Array<string>;
  delay?: number;
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => {
        const newIndex = prev + 1;
        if (!messages[newIndex]) {
          return messages.length - 1;
        }

        return newIndex;
      });
    }, delay);

    return () => clearInterval(interval);
  }, [delay, messages]);

  return (
    <IndicatorWrapper className="animate-fadeUp">
      <TypingIndicator
        label={messages[currentMessageIndex] || t('Thinking')}
        size="xl"
        inline
      />
    </IndicatorWrapper>
  );
};
